define('models/reseller_application',['require','backbone'],function(require){

    var Backbone = require('backbone');


    return Backbone.Model.extend({
        url : function() {
            // set the endpoint for restful api for articles
            return this.id ? ( App.Config.apiBase + 'reseller-applications/' + this.id + '/' ) :
                ( App.Config.apiBase + 'reseller-applications/' );
        },

        defaults: function () {
            return {
                id: null,
                company_name: '',
                phone_number: '',
                company_email: '',
                website: '',
                contact_name: '',
                contact_phone_number: '',
                contact_email: '',
                city_country: '',
                address: '',
                setup_before: false
            };
        }
    });
});
